import { render, staticRenderFns } from "./wl_look_popup.vue?vue&type=template&id=3abc3471"
import script from "./wl_look_popup.vue?vue&type=script&lang=js"
export * from "./wl_look_popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports